import layoutHeaderAside from '@/layout/header-aside'
import bus from '@/components/view-bus'

const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 用户路由
export default [
  {
    path: '/member',
    name: 'Member',
    meta: {
      title: '用户',
      auth: true
    },
    // redirect: { name: 'MemberIndex' },
    // redirect: { name: 'PigeonUser' },
    component: layoutHeaderAside,
    children: [
      {
        path: 'index',
        name: 'MemberIndex',
        meta: {
          title: '用户管理',
          auth: true
        },
        component: _import('member/member')
      },
      {
        path: 'user',
        name: 'childuser',
        meta: {
          title: '子账号管理',
          auth: true
        },
        component: _import('member/user')
      },
      {
        path: 'logs',
        name: 'logs',
        meta: {
          title: '操作日志',
          auth: true
        },
        component: _import('member/logs')
      },
      {
        path: 'loginLog',
        name: 'loginLog',
        meta: {
          title: '登录日志',
          auth: true
        },
        component: _import('member/loginLog')
      },
      {
        path: 'pigeonUser',
        name: 'PigeonUser',
        meta: {
          title: '鸽主管理',
          auth: true
        },
        component: _import('member/pigeon-user')
      },
      {
        path: 'agency',
        name: 'Agency',
        meta: {
          title: '代理管理',
          auth: true
        },
        // component: _import('member/agency-user'),
        redirect: { name: 'agencyuser' },
        component: bus,
        children: [
          {
            path: 'agencyuser',
            name: 'agencyuser',
            meta: {
              title: '代理管理',
              auth: true
            },
            component: _import('member/agency-user')
          },
          {
            path: 'agencyAdd',
            name: 'agencyAdd',
            meta: {
              title: '新建代理',
              auth: true
            },
            component: _import('member/component/agency-info')
          },
          {
            path: 'agencyEdit',
            name: 'agencyEdit',
            meta: {
              title: '编辑代理',
              auth: true
            },
            component: _import('member/component/agency-info')
          }
        ]
      },
      {
        path: 'role',
        name: 'role',
        meta: {
          title: '角色管理',
          auth: true
        },
        component: _import('member/role')
      },
      {
        path: 'addrole',
        name: 'addrole',
        meta: {
          title: '角色管理',
          auth: true
        },
        component: _import('member/addrole')
      }

    ]
  }
]
